export function route(pageContext: { urlPathname: string }) {
  // Match /, /page and /category/page
  const urlPathname = pageContext.urlPathname;
  const segments = urlPathname.split("/").filter(Boolean);

  if (segments.length === 0) {
    // Root URL: /
    return { routeParams: { page: "index" } };
  } else if (segments.length === 1) {
    // Flat URL: /resume
    return { routeParams: { page: segments[0] } };
  } else if (segments.length === 2) {
    // Nested URL: /courses/dreamjob-weekend
    return { routeParams: { category: segments[0], page: segments[1] } };
  }

  return false;
}
